import type { ShowSessionConfigOptions } from "@contexts/DialogContext/types";

/**
 * Options for the Quick Study dialog opened when no hydrated recommendation is
 * available. A formative report reopens the filters the session itself used; a
 * summative report has no meaningful filters to carry over.
 */
export const buildNextActionFallbackOptions = ({
	isSummativeTest,
	sessionTagIds,
}: {
	isSummativeTest: boolean;
	sessionTagIds: number[];
}): ShowSessionConfigOptions =>
	isSummativeTest || sessionTagIds.length === 0
		? {}
		: { selectedTagIds: sessionTagIds };
